import { useCallback } from 'react';
import { useAnimatedSwitch } from './use-animated-switch';
import { ENVIRONMENT } from '../../../env';

type DockMode = 'dock' | 'type';

export const useDock = () => {
  const { mode, isExiting, switchTo, commitNow, onExitEnd } = useAnimatedSwitch<DockMode>('dock');

  const openType = useCallback(() => {
    if (ENVIRONMENT === 'DEV') console.log('Dock: openType');
    switchTo('type');
  }, [switchTo]);

  const closeType = useCallback(() => {
    if (ENVIRONMENT === 'DEV') console.log('Dock: closeType');
    switchTo('dock');
  }, [switchTo]);

  /** Close type dock instantly (no exit animation). Used after sending a message. */
  const closeTypeImmediate = useCallback(() => {
    if (ENVIRONMENT === 'DEV') console.log('Dock: closeTypeImmediate');
    commitNow('dock');
  }, [commitNow]);

  return { mode, isExiting, onExitEnd, openType, closeType, closeTypeImmediate };
};
